import React from 'react';
import StudentLeaveBoard from '../components/StudentLeaveBoard';

// แจ้งลานักเรียนของฝ่ายปกครอง (pos 16) — แจ้งให้ใครก็ได้ และลบได้ทุกรายการ
// หน้าจอตัวจริงอยู่ที่ components/StudentLeaveBoard.js ใช้ร่วมกับหัวหน้าวิชาการสามัญ
export default function DisciplineStudentLeave() {
  return (
    <StudentLeaveBoard
      roleLabel="ฝ่ายปกครอง"
      title="แจ้งลานักเรียน (ป่วย/ลากิจ)"
      leavesPath="/api/discipline/leaves"
      searchPath="/api/discipline/conduct/students"
      intro={
        <>ฝ่ายปกครองสามารถแจ้งลาให้นักเรียนทุกคน โดยค้นหาจากเลขประจำตัวหรือชื่อ
          &nbsp;— รายการลาจะแสดงเป็นสถานะ "ลา" อัตโนมัติในหน้าเช็คชื่อรายคาบของวันที่อยู่ในช่วงลา
          (มีผลกับการเช็คชื่อ<strong>ครั้งถัดไป</strong>เท่านั้น)</>
      }
    />
  );
}
